import React, { useEffect, useState } from 'react'
import Common_Images_Transport from '../common_imges_transport/Common_Images_Transport'
import { Get_Subhmuharats } from '../../../api/global/Global';
import { IMG_BASE_URL } from '../../../config/Config';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";

import { fetchMasterData } from '../../../redux/actions/masterdataActions';
import { fetchSettingData } from '../../../redux/actions/settingAction';

const Footer = () => {
    const dispatch = useDispatch();

    // const [get_settings, setGet_Settings] = useState([]);
    const [get_subhmuharats_list, set_Get_Subhmuharats_List] = useState([]);
    const { horoscopePages, loading, error } = useSelector(
        (state) => state?.masterdata
    );
    const { settingData } = useSelector(
        (state) => state?.settingdata || []
    );
    const [activeAccordion, setActiveAccordion] = useState(null);

    useEffect(() => {
        setTimeout(() => dispatch(fetchMasterData()),
            1000
        )
    }, [dispatch]);

    useEffect(() => {
        setTimeout(() => dispatch(fetchSettingData()),
            1000
        )
    }, [dispatch]);


    useEffect(() => {
        const Handle_Get_Subhmuharat = async () => {
            try {
                const response = await Get_Subhmuharats();
                set_Get_Subhmuharats_List(response?.data?.data?.subhmuharat)
            } catch (error) {
                console.log("error", error)
            }
        }
        Handle_Get_Subhmuharat()
    }, [])

    const allowedPages = ["horoscope", "today-horoscope", "love-horoscope", "yesterday-horoscope", "tomorrow-horoscope", "weekly-horoscope", "monthly-horoscope", "yearly-horoscope"];
    // horoscopes pages
    const TodayHoroscope = horoscopePages?.find((item) => item?.page_name === "today-horoscope")
    const YesterDayHoroscope = horoscopePages?.find((item) => item?.page_name === "yesterday-horoscope")
    const TomorrowHoroscope = horoscopePages?.find((item) => item?.page_name === "tomorrow-horoscope")
    const WeeklyHoroscope = horoscopePages?.find((item) => item?.page_name === "weekly-horoscope")
    const MonthlyHoroscope = horoscopePages?.find((item) => item?.page_name === "monthly-horoscope")
    const YearlyHoroscope = horoscopePages?.find((item) => item?.page_name === "yearly-horoscope")

    // Astrology-pages

    const KundaliMatching = horoscopePages?.find((item) => item?.page_name === "kundli-matching")
    const HowToReadKundali = horoscopePages?.find((item) => item?.page_name === "how-to-read-kundli")
    const kaalsarpDoshas = horoscopePages?.find((item) => item?.page_name === "kaalsarp-doshas")
    const NakshatrasConstellations = horoscopePages?.find((item) => item?.page_name === "nakshatras-constellations")
    const Numeriology = horoscopePages?.find((item) => item?.page_name === "numerology")
    const AstrologyYoga = horoscopePages?.find((item) => item?.page_name === "astrology-yoga")
    const ChildAstrology = horoscopePages?.find((item) => item?.page_name === "child-astrology")
    const FreeKundali = horoscopePages?.find((item) => item?.page_name === "free-kundli")
    const TodayPanchang = horoscopePages?.find((item) => item?.page_name === "panchang")
    const LoveCalculator = horoscopePages?.find((item) => item?.page_name === "love-calculator")




    const toggleAccordion = (menu) => {
        setActiveAccordion(menu === activeAccordion ? null : menu);
    };

    return (
        <div>
            {/* <!-- Footer Start --> */}
            <footer className="gi-footer bg-black">
                <div className="footer-container">
                    <div className="footer-top pt-[80px] pb-[20px] max-[767px]:py-[20px] border-b border-white/20">
                        <div
                            className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1390px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                            <div className="w-full flex flex-wrap">
                                <div className="min-[992px]:w-[25%] px-[12px] w-full gi-footer-cat wow fadeInUp">
                                    <div className="gi-footer-widget gi-footer-company flex flex-col">
                                        {
                                            settingData && settingData[0]?.footer_logo != null ? (
                                                <Link to="/">
                                                    <img src={`${IMG_BASE_URL}${settingData[0]?.footer_logo}`}
                                                        className="gi-footer-logo max-w-[144px] max-[767px]:max-w-[130px]  mb-[30px]"
                                                        alt={settingData[0]?.alt_image} />
                                                </Link>
                                            ) : (
                                                <Link to="/">
                                                    <img src={Common_Images_Transport?.White_logo}
                                                        className="gi-footer-logo max-w-[144px] max-[767px]:max-w-[130px]  mb-[30px]"
                                                        alt="footer logo" />
                                                </Link>
                                            )
                                        }
                                        {
                                            settingData && (
                                                <p
                                                    className="text-white font-medium text-[12px]">
                                                    {settingData[0]?.short_description}</p>
                                            )
                                        }
                                        <div className="social_media ">
                                            <h6
                                                className="text-white font-bold text-[16px] my-3">
                                                Contact Us</h6>
                                            <div className="gi-footer-links">
                                                <ul className="align-itegi-center">
                                                    <li
                                                        className="gi-footer-link gi-foo-call gap-4 m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                        <span className="w-[25px] flex basis-auto grow-[0] shrink-[0]">
                                                            <img src={Common_Images_Transport?.headphones_head} alt="" />
                                                        </span>
                                                        <a href={`tel:${settingData[0]?.phone}`}
                                                            className="transition-all duration-[0.3s] ease-in-out md:text-[12px] 
                                                            xl:text-[14px] leading-[20px] p-[0] text-white/90 mb-[0] inline-block 
                                                            relative break-all tracking-[0] font-normal hover:text-[#9F2225]
                                                             hover:opacity-[1]">{settingData[0]?.phone}</a>
                                                        {/* <a href="#"
                                                            className="text-white/90 font-medium text-[13px] hover:text-red-800">{get_settings && get_settings[0]?.address}</a> */}
                                                    </li>
                                                    <li
                                                        className="gi-footer-link gi-foo-mail gap-4 m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                        <span className="w-[25px] flex basis-auto grow-[0] shrink-[0]">
                                                            <img src={Common_Images_Transport?.email_envelope_icon} alt="" />
                                                        </span>
                                                        <a href={`mailto:${settingData && settingData[0]?.email}`}
                                                            className="transition-all duration-[0.3s] ease-in-out md:text-[12px] 
                                                            xl:text-[14px] leading-[20px] p-[0] text-white/90 mb-[0] inline-block 
                                                            relative break-all tracking-[0] font-normal hover:text-[#9F2225]
                                                             hover:opacity-[1]">{settingData && settingData[0]?.email}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="min-[992px]:w-[16.66%] gi-footer-toggle px-[12px] w-full gi-footer-info wow fadeInUp"
                                    data-wow-delay="0.2s">
                                    <div className="gi-footer-widget">
                                        <div
                                            className="gi-footer-heading text-[16px] font-bold mb-[20px] text-[#fff] leading-[1.2] tracking-[0] relative block w-full">
                                            Horoscope
                                            <span className='float-right min-[991px]:hidden block p-1' onClick={() => toggleAccordion("horoscope")}> <svg data-accordion-icon className={`size-3 shrink-0 ${activeAccordion == "horoscope" ? 'rotate-0' : 'rotate-180'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5" />
                                            </svg></span>
                                        </div>

                                        <div className={`gi-footer-links ${activeAccordion !== "horoscope" && "gi-footer-dropdown"}`}>
                                            <ul className="align-itegi-center">
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to={`/horoscope/${MonthlyHoroscope?.slug}`}
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">Monthly Horoscope</Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to={`/horoscope/${TodayHoroscope?.slug}`}
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">Today
                                                        Horoscope</Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to={`/horoscope/${TomorrowHoroscope?.slug}`}
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">Tomorrow's Horoscope</Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to={`/horoscope/${WeeklyHoroscope?.slug}`}
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">Weekly Horoscope</Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to={`/horoscope/${YesterDayHoroscope?.slug}`}
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">Yesterday Horoscope</Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to={`/horoscope/${YearlyHoroscope?.slug}`}
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">Yearly Horoscope</Link>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                                <div className="min-[992px]:w-[16.66%] gi-footer-toggle px-[12px] w-full gi-footer-account wow fadeInUp"
                                    data-wow-delay="0.3s">
                                    <div className="gi-footer-widget">
                                        <div
                                            className="gi-footer-heading text-[16px] font-bold mb-[20px] text-[#fff] leading-[1.2] tracking-[0] relative block w-full">
                                            Important Links
                                            <span className='float-right min-[991px]:hidden block p-1' onClick={() => toggleAccordion("importantlink1")}> <svg data-accordion-icon className={`size-3 shrink-0 ${activeAccordion == "importantlink1" ? 'rotate-0' : 'rotate-180'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5" />
                                            </svg></span>
                                        </div>
                                        <div className={`gi-footer-links ${activeAccordion !== "importantlink1" && "gi-footer-dropdown"}`}>
                                            <ul className="align-itegi-center">
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to="/blogs"
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">Blogs</Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to={`/page/${FreeKundali?.slug}`}
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Free Kundali
                                                    </Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to={`/page/${HowToReadKundali?.slug}`}
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">How
                                                        to Read kundli
                                                    </Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to={`/page/${kaalsarpDoshas?.slug}`}
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Kaalsarp Doshas
                                                    </Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to={`/page/${KundaliMatching?.slug}`}
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Kundali Matching
                                                    </Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to={`/page/${NakshatrasConstellations?.slug}`}
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Nakshatras Constellations
                                                    </Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to={`/page/${Numeriology?.slug}`}
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Numerology
                                                    </Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to={`/page/${TodayPanchang?.slug}`}
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">Today
                                                        Panchang</Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="min-[992px]:w-[21%] gi-footer-toggle px-[12px] w-full gi-footer-service wow fadeInUp"
                                    data-wow-delay="0.4s">
                                    <div className="gi-footer-widget">
                                        <div
                                            className="gi-footer-heading text-[16px] font-bold mb-[20px] text-[#fff] leading-[1.2] tracking-[0] relative block w-full">
                                            Shubh Muhurats
                                            <span className='float-right min-[991px]:hidden block p-1' onClick={() => toggleAccordion("subhmuhurat")}> <svg data-accordion-icon className={`size-3 shrink-0 ${activeAccordion == "subhmuhurat" ? 'rotate-0' : 'rotate-180'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5" />
                                            </svg></span>
                                        </div>
                                        <div className={`gi-footer-links ${activeAccordion !== "subhmuhurat" && "gi-footer-dropdown"}`}>
                                            <ul className="align-itegi-center">
                                                {
                                                    get_subhmuharats_list?.map((get_subhmuharats_list_result, ind) => {
                                                        return (

                                                            <li key={ind + 1} className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[14px]">
                                                                <Link
                                                                    to={`/subh-muhurat/${get_subhmuharats_list_result?.slug}`}
                                                                    className="text-white/90 font-medium text-[13px] hover:text-red-800">

                                                                    {get_subhmuharats_list_result?.title}
                                                                </Link>
                                                            </li>

                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="min-[992px]:w-[16.66%] gi-footer-toggle px-[12px] w-full gi-footer-service wow fadeInUp hidden"
                                    data-wow-delay="0.4s">
                                    <div className="gi-footer-widget">
                                        <div
                                            className="gi-footer-heading text-[16px] font-bold mb-[20px] text-[#fff] leading-[1.2] tracking-[0] relative block w-full">
                                            Important Links
                                            <span className='float-right min-[991px]:hidden block p-1' onClick={() => toggleAccordion("importantlink2")}> <svg data-accordion-icon className={`size-3 shrink-0 ${activeAccordion == "importantlink2" ? 'rotate-0' : 'rotate-180'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5" />
                                            </svg></span>
                                        </div>
                                        <div className={`gi-footer-links ${activeAccordion !== "importantlink2" && "gi-footer-dropdown"}`}>
                                            <ul className="align-itegi-center">
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to="/blogs"
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Blog
                                                    </Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to="/planetary-transit-2025"
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Planetary Transit 2025 New
                                                    </Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to="/collaboration"
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Collaboration
                                                    </Link>
                                                </li>
                                                {/* <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <a href="#"
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Tarot
                                                    </a>
                                                </li> */}
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to="/zodiac-signs"
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Zodiac Signs
                                                    </Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to="/vastu-shastra"
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Vastu Shastra
                                                    </Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to="/solar-eclipse-2025"
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Solar Eclipse 2025
                                                    </Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to="/lunar-eclipse-2025"
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Lunar Eclipse 2025
                                                    </Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to="/festivals"
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Festival Calendar 2025
                                                    </Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to="/vrat-calendar-2025"
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Vrat Calendar 2025
                                                    </Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to="/mole-astrology"
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Mole Astrology
                                                    </Link>
                                                </li>
                                                <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <Link to="/love-calculator"
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Love Calculator
                                                    </Link>
                                                </li>
                                                {/* <li
                                                    className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                    <a href="#"
                                                        className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                        Astrotalk Sitemap
                                                    </a>
                                                </li> */}

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="min-[992px]:w-[20%] gi-footer-toggle px-[12px] w-full gi-footer-cont-social mb-[-20px] wow fadeInUp"
                                    data-wow-delay="0.5s">
                                    <div className="gi-footer-contact mb-[30px] max-[991px]:mb-[0]">
                                        <div className="gi-footer-widget">
                                            <div
                                                className="gi-footer-heading text-[16px] font-bold mb-[20px] text-[#fff] leading-[1.2] tracking-[0] relative block w-full">
                                                Astrologer
                                                <span className='float-right min-[991px]:hidden block p-1' onClick={() => toggleAccordion("astrologer")}> <svg data-accordion-icon className={`size-3 shrink-0 ${activeAccordion == "astrologer" ? 'rotate-0' : 'rotate-180'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5" />
                                                </svg></span>
                                            </div>
                                            <div className={`gi-footer-links ${activeAccordion !== "astrologer" && "gi-footer-dropdown"}`}>
                                                <ul className="align-itegi-center">
                                                    <li
                                                        className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                        <Link to={`/page/${AstrologyYoga?.slug}`}
                                                            className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                            Astrology Yoga
                                                        </Link>
                                                    </li>
                                                    <li
                                                        className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                        <Link to="/astrologer-list"
                                                            className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                            Chat with Astrologer
                                                        </Link>
                                                    </li>
                                                    <li
                                                        className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                        <Link to={`/page/${ChildAstrology?.slug}`}
                                                            className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                            Child Astrology
                                                        </Link>
                                                    </li>
                                                    <li
                                                        className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                        <Link to="/download-app"
                                                            className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                            Live Astrologers
                                                        </Link>
                                                    </li>
                                                    <li
                                                        className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center mb-[12px]">
                                                        <Link to="/astrologer-list"
                                                            className="text-white/90 font-medium text-[13px] hover:text-red-800">
                                                            Talk to Astrologer
                                                        </Link>
                                                    </li>
                                                </ul>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="gi-footer-social">
                                        <div className="gi-footer-widget">
                                            <div
                                                className="gi-footer-heading text-[16px] font-bold mb-[20px] text-[#fff] leading-[1.2] tracking-[0] relative block w-full">
                                                App Download</div>
                                            <div className="gi-footer-links">
                                                <div
                                                    className="gi-app-store mb-[30px] flex flex-row max-[1199px]:flex-col max-[991px]:flex-row max-[320px]:flex-col">
                                                    <a href={`${settingData && settingData[0]?.play_store}`} target='_blank' className="app-img"><img src={Common_Images_Transport?.android}
                                                        className="adroid max-w-[140px] max-[1399px]:max-w-[120px]  mb-[15px] rounded-[5px] mr-[15px]"
                                                        alt="apple" /></a>
                                                    <a href={`${settingData && settingData[0]?.app_store}`} target='_blank' className="app-img"><img src={Common_Images_Transport?.apple}
                                                        className="apple max-w-[140px] max-[1399px]:max-w-[120px] mb-[15px] rounded-[5px]"
                                                        alt="apple" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="gi-footer-contact flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1390px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] px-3 pt-3 lg:pt-0">
                        <div className="gi-footer-widget w-full lg:flex justify-between gap-3 items-center">
                            <div className={`gi-footer-links`}>
                                <ul className="grid grid-cols-2  sm:flex gap-3 justify-center items-center">
                                    <li
                                        className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center">
                                        <Link to="/terms-conditions"
                                            className="text-white/90 font-medium text-[13px] sm:text-[12px] hover:text-red-800">
                                            Terms & Conditions
                                        </Link>
                                    </li>
                                    <li
                                        className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center">
                                        <Link to="/privacy-policy"
                                            className="text-white/90 font-medium text-[13px] sm:text-[12px] hover:text-red-800">
                                            Privacy Policy
                                        </Link>
                                    </li>

                                    <li
                                        className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center">
                                        <Link to="/about-us"
                                            className="text-white/90 font-medium text-[13px] sm:text-[12px] hover:text-red-800">
                                            About Us
                                        </Link>
                                    </li>

                                    <li
                                        className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center">
                                        <a href="/shipping-policy"
                                            className="text-white/90 font-medium text-[13px] sm:text-[12px] hover:text-red-800">
                                            Shipping Policy
                                        </a>
                                    </li>
                                    <li
                                        className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center">
                                        <a href="/return-policy"
                                            className="text-white/90 font-medium text-[13px] sm:text-[12px] hover:text-red-800">
                                            Return Policy
                                        </a>
                                    </li>
                                    <li
                                        className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center">
                                        <a href="/payment-method"
                                            className="text-white/90 font-medium text-[13px] sm:text-[12px] hover:text-red-800">
                                            Payment Method
                                        </a>
                                    </li>
                                    <li
                                        className="gi-footer-link m-[0] leading-[1.5] border-[0] p-[0] font-normal flex items-center">
                                        <Link to="https://rasatva.parasmesoft.in/omens/sitemap.xml" target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-white/90 font-medium text-[13px] sm:text-[12px] hover:text-red-800">
                                            Sitemap
                                        </Link>
                                    </li>
                                </ul>

                            </div>

                            <div className="gi-footer-social my-[20px] ">
                                <div className="gi-footer-widget">
                                    <div className="gi-footer-links">
                                        <ul className="justify-center flex flex-wrap">
                                            <li className="gi-footer-link pr-[5px]">
                                                <a href={settingData && settingData[0]?.facebook} target='_blank'
                                                    className="h-[30px] w-[30px] bg-[#4b5966] rounded-[5px] capitalize flex items-center justify-center text-[15px]"><i
                                                        className="gicon gi-facebook text-[16px] text-[#fff]"
                                                        aria-hidden="true"></i></a>
                                            </li>

                                            <li className="gi-footer-link pr-[5px]">
                                                <a href={settingData && settingData[0]?.linkdin} target='_blank'
                                                    className="h-[30px] w-[30px] bg-[#4b5966] rounded-[5px] capitalize flex items-center justify-center text-[15px]"><i
                                                        className="gicon gi-linkedin text-[16px] text-[#fff]"
                                                        aria-hidden="true"></i></a>
                                            </li>
                                            <li className="gi-footer-link pr-[5px]">
                                                <a href={settingData && settingData[0]?.instagram} target='_blank'
                                                    className="h-[30px] w-[30px] bg-[#4b5966] rounded-[5px] capitalize flex items-center justify-center text-[15px]"><i
                                                        className="gicon gi-instagram text-[16px] text-[#fff]"
                                                        aria-hidden="true"></i></a>
                                            </li>
                                            <li className="gi-footer-link pr-[5px]">
                                                <a href={settingData && settingData[0]?.twitter} target='_blank'
                                                    className="h-[30px] w-[30px] bg-[#4b5966] rounded-[5px] capitalize flex items-center justify-center text-[15px]"><i
                                                        className="gicon gi-twitter text-[16px] text-[#fff]"
                                                        aria-hidden="true"></i></a>
                                            </li>
                                            <li className="gi-footer-link pr-[5px]">
                                                <a href={settingData && settingData[0]?.youtube} target='_blank'
                                                    className="h-[30px] w-[30px] bg-[#4b5966] rounded-[5px] capitalize flex items-center justify-center text-[15px]"><i
                                                        className="gicon gi-youtube text-[16px] text-[#fff]"
                                                        aria-hidden="true"></i></a>
                                            </li>
                                            <li className="gi-footer-link pr-[5px]">
                                                <a href={settingData && settingData[0]?.Pinterest} target='_blank'
                                                    className="h-[30px] w-[30px] bg-[#4b5966] rounded-[5px] capitalize flex items-center justify-center text-[15px]"><i
                                                        className="gicon gi-pinterest text-[16px] text-[#fff]"
                                                        aria-hidden="true"></i></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="footer-bottom py-[10px] max-[991px]:py-[15px] border-t-[1px] border-solid border-[#eee] bg-[#f8f8fb]">
                        <div
                            className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                            <div className="w-full">
                                <div className="gi-bottom-info text-center">
                                    <div className="footer-copy">
                                        <div className="footer-bottom-copy">
                                            <div className="gi-copy text-gray-900 font-medium text-[13px] tracking-[1px] text-center">
                                                Copyright ©
                                                <Link className="site-name text-[#9F2225]" to="/">Omens </Link>
                                                all rights reserved. Powered by Omens.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="footer-bottom-right">
                                        <div className="footer-bottom-payment flex justify-content-center">
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </footer>
            <a target="_blank" href="https://wa.me/8565707894?text=Hello,%20Welcome%20to%20Omens"
                className="fixed bottom-10 right-10 btn shadow-lg w-16 h-16 flex bg-green-600 text-center text-[14px] uppercase justify-center bg-[#4b5966] text-[#fff] transition-all duration-[0.3s] ease-in-out rounded-[100%] items-center font-semibold tracking-[0.02rem] border-[0] hover:bg-[#333] hover:text-[#fff] z-20"><i
                    className="gicon gi-whatsapp transition-all duration-[0.3s] ease-in-out leading-[0] !text-xl"></i></a>
        </div>
    )
}

export default Footer